import script from "./ModalGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalGallery.vue?vue&type=script&setup=true&lang=js"

import "./ModalGallery.vue?vue&type=style&index=0&id=abba5db8&lang=css"

const __exports__ = script;

export default __exports__